import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { variables } from "../variables";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    height: "40",
    paddingLeft: "20"
  },
});

const PdfTableRow = ({ data, customStyle }) => {
  const rows = data.map((item, idx) => {
    const className = { ...styles.row };
    idx % 2 && (className.backgroundColor = variables.stripedColor);
    return (
      <View style={className} key={idx}>
        {Object.entries(item).map(([key,value]) => (
          <Text key={key} style={[styles[key], customStyle["row"][key]]}>
            {value.toString()}
          </Text>
        ))}
      </View>
    );
  });
  return <Fragment>{rows}</Fragment>;
};

export default PdfTableRow;